function toParams (arr = []) {
  if (typeof arr === 'string') {
    arr = arr.split(/,|，/);
  }
  let names = ['category', 'action', 'label'];
  let obj = {};
  arr.map((v, i) => {
    obj[names[i]] = (v || '').trim();
  });

  return obj
}

export default toParams;



// WEBPACK FOOTER //
// ./src/plugins/toAnalysisParams.js